// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerFile_root__j8J0f"};